import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { parse } from 'qs';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import ForgotPassword from '../../components/ForgotPassword';
import ResetPassword from '../../components/ResetPassword';
import { smoothScroll } from '../../helpers/view';

class ForgotPasswordContainer extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    if (this.props.user.loggedIn) {
      this.props.staticContext.page.status = 302;
      this.props.history.push('/');
    }
  }

  componentDidMount() {
    smoothScroll();
  }

  get token() {
    const { location: { search } } = this.props;
    const { token } = parse(search.slice(1));

    return token;
  }

  render() {
    return (
      <Fragment>
        <Helmet defer={false}>
          <title>Reset Passwords at Mp3Caprice</title>
          <meta property="mc:dp" content={`/shop/reset-password${this.token ? '/token' : ''}`} />
          <meta property="mc:page" content="Reset Password" />
        </Helmet>
        {this.token ? <ResetPassword /> : <ForgotPassword />}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default withRouter(connect(mapStateToProps)(ForgotPasswordContainer));
